/* eslint-disable */
export default {
  userp: state => state.userp,
  access_tokenp: state => state.access_tokenp,
  isLoggedIn: state => !!state.access_tokenp,
  //isAuthenticated: state => !!state.access_token
  isAdmin: state => state.rolep.includes('Admin'),
  isClient: state => state.rolep.includes('Client'),
};
